import React, { useState } from 'react';
import { Divider, Tag, Steps, Pagination, Tooltip, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import IconExpand from '../../../../assets/Images/icons/icon-expand';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../../assets/Images/icons/empty';
import useQuery from '../../../../util/useQuery';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ROUTER } from '../../../../constants/router';
function ListCard({
    dataSource,
    onChangePage,
    currentPage,
    loading,
    setLoading,
    requestType,
}) {
    return (
        <div>
            <Spin spinning={!dataSource && dataSource !== null}>
                <div className="overflow-auto h-[58vh] grid gap-3">
                    {dataSource?.length > 0 ? (
                        <div className="space-y-2">
                            {dataSource?.map((item) => (
                                <Card
                                    requestType={requestType}
                                    key={item?.dsrTaskId}
                                    item={item}
                                />
                            ))}
                        </div>
                    ) : (
                        <div
                            hidden={loading}
                            className="h-[35vh] grid items-center justify-center"
                        >
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
            <div className="w-full text-right mt-4">
                <Pagination
                    pageSizeOptions={[10, 25, 50]}
                    defaultPageSize={10}
                    total={currentPage?.total || 1}
                    current={currentPage?.page || 1}
                    showSizeChanger
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        onChangePage(pageValue);
                    }}
                />
            </div>
        </div>
    );
}

const Card = ({ item, requestType }) => {
    const { Step } = Steps;
    const params = useQuery();
    const { t } = useTranslation();
    const [expand, setExpand] = useState(false);
    const Navigate = useNavigate();
    const _getTagDay = (e) => {
        if (e > 30) {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    <div className="flex items-center gap-x-1">
                        <div>{e}</div>
                        <Tooltip
                            className="cursor-pointer"
                            placement="right"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('MyTask.TooltipExtendDayLeft')}
                                </div>
                            }
                        >
                            <div className="text-xs">
                                <InfoCircleOutlined />
                            </div>
                        </Tooltip>
                    </div>
                </Tag>
            );
        } else if (e <= 0) {
            return (
                <Tag className="text-xs rounded-xl -my-1" color="#F0536F">
                    {e}
                </Tag>
            );
        } else if (e <= 7) {
            return (
                <Tag className="text-xs rounded-xl -my-1" color="#F9C153">
                    {e}
                </Tag>
            );
        } else {
            return (
                <Tag className="text-xs rounded-xl -my-1" color="#1890FF">
                    {e}
                </Tag>
            );
        }
    };
    const _getTagStatus = (e) => {
        switch (e) {
            case 'Doing':
                return {
                    color: '#F9C153',
                    borderColor: '#F9C153',
                    width: '110px',
                };
            case 'Task Done':
                return {
                    color: '#4ACE8F',
                    borderColor: '#4ACE8F',
                    width: '110px',
                };
            case 'Task Canceled':
                return {
                    color: '#F0536F',
                    borderColor: '#F0536F',
                    width: '110px',
                };
            case 'Task Canceling':
                return {
                    color: '#65707A',
                    borderColor: '#65707A',
                    width: '110px',
                };
            case 'To Do':
                return {
                    color: '#1890FF',
                    borderColor: '#1890FF',
                    width: '110px',
                };
            case 'New':
                return { color: '#1890FF', borderColor: '#1890FF' };
            case 'Verified':
                return { color: '#7B67FB', borderColor: '#7B67FB' };
            case 'Assigned':
                return { color: '#65707A', borderColor: '#65707A' };
            case 'Preparing':
                return { color: '#65707A', borderColor: '#65707A' };
            case 'In Progress':
                return { color: '#F9C153', borderColor: '#F9C153' };
            case 'Done':
                return { color: '#4ACE8F', borderColor: '#4ACE8F' };
            case 'Reject':
                return { color: '#F0536F', borderColor: '#F0536F' };
            default:
                return { color: '#FFF', background: '' };
        }
    };

    const customDot = (dot, { status, index }) => (
        <div
            style={{
                position: 'absolute',
                top: '-8px',
                left: status === 'process' ? '-31px' : '-30px',
                width: '60px',
                height: '32px',
            }}
        >
            {status === 'wait'
                ? WaitingCircle
                : status === 'error'
                ? RejectCircle
                : status === 'process'
                ? InProgressCircle
                : CorrectCircle}
            {/* {status === 'wait'
                ? WaitingCircle
                : status === 'error'
                ? RejectCircle
                : CorrectCircle} */}
        </div>
    );
    const lastSequence = (workflowList) => {
        const seq = workflowList?.filter((res) => res?.inProgress === true)[0];
        if (!seq) {
            return workflowList?.length;
        } else {
            return seq?.sequence - 1;
        }
    };

    const requestTypeName = requestType?.find(
        (res) => res.id === item?.requestTypeId
    );

    return (
        <div className="flex bg-white w-full pt-4 px-3 rounded-lg">
            <div className="w-full">
                <div
                    className="grid grid-cols-2 mt-2 cursor-pointer"
                    onClick={() => {
                        const tab = params.get('tab');
                        switch (tab) {
                            case '1':
                                Navigate(
                                    `${ROUTER.DS_360.MY_TASK}/${
                                        item?.pleasePerformName ===
                                        'Cancel Task'
                                            ? 'cancel-task'
                                            : 'todolist'
                                    }/${item?.dsrTaskId}`
                                );
                                break;
                            case '2':
                                Navigate(
                                    `${ROUTER.DS_360.MY_TASK}/${'follow-up'}/${
                                        item?.dsrTaskId
                                    }`
                                );
                                break;
                            case '3':
                                Navigate(
                                    `${
                                        ROUTER.DS_360.MY_TASK
                                    }/${'operation-done'}/${item?.dsrTaskId}`
                                );
                                break;
                            case '4':
                                Navigate(
                                    `${
                                        ROUTER.DS_360.MY_TASK
                                    }/${'request-done'}/${item?.dsrTaskId}`
                                );
                                break;
                            default:
                                Navigate(
                                    `${ROUTER.DS_360.MY_TASK}/${
                                        item?.pleasePerformName ===
                                        'Cancel Task'
                                            ? 'cancel-task'
                                            : 'todolist'
                                    }/${item?.dsrTaskId}`
                                );
                                break;
                        }
                    }}
                >
                    <div className="space-y-2">
                        <div className="grid grid-cols-4 text-xs">
                            <strong className="text-xs col-span-1">
                                {t('MyTask.RequestID')} :
                            </strong>
                            <div className="col-span-3">
                                {item?.requestId || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-4 text-xs">
                            <strong className="text-xs col-span-1">
                                {t('MyTask.RequestDate')} :
                            </strong>
                            <div className="col-span-3">
                                {moment(item?.requestDate).format(
                                    'DD/MM/YYYY'
                                ) || '-'}
                            </div>
                            {/* <div>
                                {item?.statusEn ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center"
                                        style={_getTagStatus(item?.statusEn)}
                                    >
                                        {i18n?.language === 'en'
                                            ? item?.statusEn || '-'
                                            : item?.statusTh || '-'}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div> */}
                        </div>
                        <div className="grid grid-cols-4 text-xs">
                            <strong className="text-xs col-span-1">
                                {t('MyTask.RequestStatus')} :
                            </strong>
                            <div className="col-span-3">
                                {item?.requestStatusName ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center"
                                        style={_getTagStatus(
                                            item?.requestStatusName
                                        )}
                                    >
                                        {item?.requestStatusName || '-'}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-4 text-xs">
                            <strong className="text-xs col-span-1">
                                {t('MyTask.DataSubjectName')} :
                            </strong>
                            <div className="col-span-3">
                                {item?.dsName || '-'}
                            </div>
                        </div>
                        <div className="flex gap-x-1 items-center text-sm font-semibold">
                            <div className="text-[#7B67FB]">
                                {item?.dsTypeName}
                            </div>
                            <div>{t('MyTask.RequestTo')}</div>
                            <div className="text-[#7B67FB]">
                                {requestTypeName?.value}
                            </div>
                        </div>
                    </div>
                    <div className="space-y-2">
                        <div className="flex gap-x-1 text-xs">
                            <strong className="text-xs">
                                {t('MyTask.DayLeft')} :
                            </strong>
                            <div>
                                {item?.requestStatusName === 'Reject' ||
                                item?.requestStatusName === 'Archived' ||
                                item?.requestStatusName === 'Done'
                                    ? '-'
                                    : _getTagDay(item?.dayLeft)}
                            </div>
                        </div>
                        <div className="flex gap-x-1 text-xs">
                            <strong className="text-xs">
                                {t('MyTask.SendRequestFrom')}
                            </strong>
                            <div className="text-[#7B67FB] font-semibold">
                                {item?.domainName}
                            </div>
                        </div>
                        {(!params.get('tab') || params.get('tab') === '1') && (
                            <div className="flex gap-x-2 text-xs">
                                <strong className="text-xs">
                                    {t('MyTask.PleasePerform')}{' '}
                                </strong>
                                <div>
                                    {item?.pleasePerformName ? (
                                        <Tag
                                            className="rounded-xl -my-1 text-center"
                                            style={{
                                                borderColor: '#7B67FB',
                                                color: '#fff',
                                                backgroundColor: '#7B67FB',
                                            }}
                                        >
                                            {item?.pleasePerformName || '-'}
                                        </Tag>
                                    ) : (
                                        <>-</>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Divider className="mb-2" />
                {expand && (
                    <div className="space-y-2">
                        <div className="text-sm font-semibold">
                            {t('MyTask.WorkflowStep')}
                        </div>
                        <div className="bg-[#F5F6FF] rounded-lg p-5 items-center">
                            <div className="grid grid-cols-2">
                                <div className="flex-column">
                                    <div className="text-sm font-semibold">
                                        {t('MyTask.Step')}
                                    </div>
                                    <div>
                                        <Steps
                                            className="custome-step pl-2"
                                            direction="vertical"
                                            progressDot={customDot}
                                            current={lastSequence(
                                                item?.workflowStep
                                            )}
                                        >
                                            {item?.workflowStep?.map((res) => (
                                                <Step
                                                    // error
                                                    // finish
                                                    // process
                                                    // wait
                                                    status={
                                                        res?.timeline ===
                                                        'rejected'
                                                            ? 'error'
                                                            : res?.timeline ===
                                                              'done'
                                                            ? 'finish'
                                                            : res?.timeline ===
                                                              'inprogress'
                                                            ? 'process'
                                                            : 'wait'
                                                        // res?.isReject &&
                                                        // res?.checked
                                                        //     ? 'error'
                                                        //     : res?.checked
                                                        //     ? 'finish'
                                                        //     : 'wait'
                                                    }
                                                    title={
                                                        <span className="text-sm font-semibold">
                                                            {res?.stepName}
                                                        </span>
                                                    }
                                                />
                                            ))}
                                        </Steps>
                                    </div>
                                </div>
                                <div>
                                    <div className="text-sm font-semibold">
                                        {t('MyTask.ResponsiblePerson')}
                                    </div>

                                    <div className="grid grid-cols-1">
                                        {item?.workflowStep?.map((res) => {
                                            if (
                                                res?.stateNameEn ===
                                                'Complete Task'
                                            ) {
                                                return (
                                                    <div
                                                        className="min-h-[48px] leading-[33px]"
                                                        style={{
                                                            color:
                                                                res?.timeline !==
                                                                'incoming'
                                                                    ? '#7B67FB'
                                                                    : 'rgba(0, 0, 0, 0.45)',
                                                        }}
                                                    >
                                                        {t(
                                                            'MyTask.OperationDepartment'
                                                        )}
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div
                                                        className="min-h-[48px] leading-[33px]"
                                                        style={{
                                                            color:
                                                                res?.timeline !==
                                                                'incoming'
                                                                    ? '#171717'
                                                                    : 'rgba(0, 0, 0, 0.45)',
                                                        }}
                                                    >
                                                        {res?.responsiblePerson ||
                                                            `-`}
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {item?.requestStatusName === 'Reject' ? (
                            <>
                                <div className="text-sm font-semibold">
                                    {t('MyTask.ReasonReject')} :
                                </div>
                                <div className="whitespace-pre-line">
                                    {item?.reasonReject || '-'}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="text-sm font-semibold">
                                    {t('MyTask.OperationDepartment')} :
                                </div>
                                <div className="text-sm font-semibold space-y-3">
                                    {item?.operationDepartment?.length > 0 ? (
                                        <>
                                            {item?.operationDepartment?.map(
                                                (res) => (
                                                    <div className="bg-[#F5F6FF] grid grid-cols-2 p-3 rounded-[10px]">
                                                        <div className="flex items-center gap-x-2">
                                                            <Tag
                                                                className="rounded-xl -my-1 text-center"
                                                                style={_getTagStatus(
                                                                    res?.operationTaskStatus
                                                                )}
                                                            >
                                                                {res?.operationTaskStatus ||
                                                                    '-'}
                                                            </Tag>
                                                            {
                                                                res?.departmentName
                                                            }
                                                        </div>
                                                        <div className="flex items-center gap-x-2">
                                                            <div>
                                                                {t(
                                                                    'MyTask.OperationPerson'
                                                                )}{' '}
                                                                :
                                                            </div>
                                                            <span className="font-normal">
                                                                {
                                                                    res?.operationPerson
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </>
                                    ) : (
                                        <>-</>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div className="flex-column">
                    {expand && <Divider className="mb-0" />}
                    <div
                        className="flex justify-center items-center gap-1 hover:animate-bounce duration-1000 cursor-pointer transition"
                        onClick={() => {
                            setExpand(!expand);
                        }}
                    >
                        <div className="">
                            <div
                                className={`w-full text-center py-2  
                        ${expand && 'rotate-180'}`}
                            >
                                <IconExpand />
                            </div>
                        </div>
                        <div>
                            {expand ? 'Collapse' : 'Expand'} Operation Info.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InProgressCircle = (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11"
            cy="11"
            r="10.7143"
            fill="white"
            stroke="#F9C153"
            strokeWidth="0.571429"
        />
        <path
            d="M10.9998 2.35791C6.22646 2.35791 2.35693 6.22744 2.35693 11.0007C2.35693 15.774 6.22646 19.6436 10.9998 19.6436C15.7731 19.6436 19.6426 15.774 19.6426 11.0007C19.637 6.22974 15.7708 2.36347 10.9998 2.35791Z"
            fill="#F9C153"
        />
        <g clipPath="url(#clip0_7276_68594)">
            <path
                d="M11 14.5664C10.466 14.5664 10.0332 14.9993 10.0332 15.5332C10.0332 16.0672 10.466 16.5 11 16.5C11.534 16.5 11.9668 16.0672 11.9668 15.5332C11.9668 14.9993 11.534 14.5664 11 14.5664Z"
                fill="white"
            />
            <path
                d="M11 5.5C10.466 5.5 10.0332 5.93285 10.0332 6.4668V12.8906C10.0332 13.4246 10.466 13.8574 11 13.8574C11.534 13.8574 11.9668 13.4246 11.9668 12.8906V6.4668C11.9668 5.93285 11.534 5.5 11 5.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_7276_68594">
                <rect
                    width="11"
                    height="11"
                    fill="white"
                    transform="translate(5.5 5.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

const WaitingCircle = (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.0005 0C4.92507 0 0 4.92507 0 11.0005C0 17.0758 4.92507 22.0009 11.0005 22.0009C17.0758 22.0009 22.0009 17.0758 22.0009 11.0005C21.9938 4.928 17.0729 0.00707216 11.0005 0Z"
            fill="#B7B7C0"
        />
    </svg>
);

const CorrectCircle = (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11"
            cy="11"
            r="10.5357"
            fill="white"
            stroke="#4ACE8F"
            strokeWidth="0.928571"
        />
        <path
            d="M11.0022 2.35547C6.2289 2.35547 2.35938 6.22499 2.35938 10.9983C2.35937 15.7716 6.2289 19.6411 11.0022 19.6411C15.7755 19.6411 19.645 15.7716 19.645 10.9983C19.6395 6.2273 15.7732 2.36103 11.0022 2.35547Z"
            fill="#4ACE8F"
        />
        <path
            d="M15.3035 8.26272L10.3735 14.953C10.2559 15.109 10.0806 15.2112 9.88693 15.2367C9.69326 15.2621 9.49747 15.2087 9.34357 15.0884L5.82306 12.2737C5.5124 12.0251 5.46209 11.5717 5.7107 11.2611C5.95931 10.9504 6.41269 10.9001 6.72335 11.1487L9.65903 13.4974L14.1439 7.41068C14.291 7.19 14.5475 7.06798 14.8115 7.09309C15.0755 7.11819 15.3043 7.28635 15.4072 7.5308C15.51 7.77525 15.4702 8.05644 15.3035 8.26272Z"
            fill="#F9F9F9"
        />
    </svg>
);

const RejectCircle = (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11"
            cy="11"
            r="10.7143"
            fill="white"
            stroke="#F0536F"
            strokeWidth="0.571429"
        />
        <path
            d="M10.9998 2.35791C6.22646 2.35791 2.35693 6.22744 2.35693 11.0007C2.35693 15.774 6.22646 19.6436 10.9998 19.6436C15.7731 19.6436 19.6426 15.774 19.6426 11.0007C19.637 6.22974 15.7708 2.36347 10.9998 2.35791Z"
            fill="#F0536F"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9337 7.06577C15.1881 7.32012 15.1881 7.73251 14.9337 7.98687L7.98638 14.9342C7.73202 15.1886 7.31963 15.1886 7.06528 14.9342C6.81092 14.6799 6.81092 14.2675 7.06528 14.0131L14.0126 7.06577C14.267 6.81141 14.6794 6.81141 14.9337 7.06577Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.06528 7.06577C7.31963 6.81141 7.73202 6.81141 7.98638 7.06577L14.9337 14.0131C15.1881 14.2675 15.1881 14.6799 14.9337 14.9342C14.6794 15.1886 14.267 15.1886 14.0126 14.9342L7.06528 7.98687C6.81092 7.73251 6.81092 7.32012 7.06528 7.06577Z"
            fill="white"
        />
    </svg>
);
export default ListCard;
